import React from 'react';

import CustomComponent from '../CustomComponent';

import { appMethod as app } from '@utils/app';
import { convertStyleData, transformPx2Rem } from '@utils/tools';
import util from '@utils/util';
import * as customEvent from '@utils/customEvent';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './DynamicClassifyCustomComponent.less';

const DynamicClassifyModule = {
  pxToRpx: (size) => {
    return transformPx2Rem(size, 320);
  },
  isImage: (string, childStr) => {
    var a = string || childStr + '1';
    return a.indexOf(childStr);
  },
  RGB2RGBA: (rgb_color,alp) => {
    if(rgb_color && rgb_color.indexOf('rgb') >= 0) {
      var rgba = rgb_color.split(')')[0] + ',' + alp + ')';
      return rgba.replace('rgb','rgba');
    }else if(rgb_color && rgb_color.indexOf('#') >= 0){
      var sColor = rgb_color.toLowerCase();
      if(sColor.length === 4){
          var sColorNew = "#";
          for (var i = 1; i < 4; i++) {
            sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
          }
          sColor = sColorNew;
      }
      var sColorChange = [];
      for (var i = 1; i < 7; i += 2) {
        sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
      }
      return "rgba(" + sColorChange.join(",") +','+ alp + ")";
    }else{
      return ''
    }
  },
  getCategoryLen: (data,id) => {
    var len = 0;
    data.map(function(item){
      if(item.category_id == id){
        len = item.subclass.length;
      }
    })
    return len;
  },
}
/**
 * type: "dynamic-classify" 
 * 组件：动态分类组件
 */
export default class DynamicClassifyCustomComponent extends React.Component {
  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }
  init = (compindex, pageInstance) => {
    let _this = this;
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let cateReqUrl = '/index.php?r=appData/getCategoryByGroup';
    let cateParam = {group_id: customFeature.dynamicClassifyGroupId || ''};
    let newdata = {};

    let classifyType = compData.classifyType;
    let classifyStyle = compData.classifyStyle;
    // 一级竖版、一级竖版带图、二级竖版带图、二级竖版无图
    if (compData.classifyType === 'level1-vertical' || compData.classifyType === 'level1-vertical-withpic' || compData.classifyType === 'level2-vertical-withpic' ||  compData.classifyType === 'level2-vertical-nopic') {
      let classifyItemStyle = {
        width: Math.floor(10000 / customFeature.everyLineNum) / 100 + '%',
        marginBottom: transformPx2Rem(classifyStyle['margin-bottom'], 320)
      };
      let listIconStyle = convertStyleData({
        width: classifyStyle['classify-icon-size'],
        height: classifyStyle['classify-icon-size'],
      });
      let imgStyle = convertStyleData({
        'width': classifyStyle['icon-size'],
        'height': classifyStyle['icon-size'],
        'font-size': classifyStyle['icon-size'],
      });

      let textStyle = {};
      if (compData.classifyType === 'level1-vertical-withpic') {
        textStyle = {
          fontSize: transformPx2Rem(classifyStyle['font-size'], 320),
          fontWeight: classifyStyle['font-weight'] || 'normal',
          fontStyle: classifyStyle['font-style'] || 'normal',
          textDecoration: classifyStyle['text-decoration'] || 'none',
          lineHeight: transformPx2Rem(classifyStyle['line-height'], 320),
          color: classifyStyle['color'] || '',
        };
      }else {
        textStyle = {
          fontSize: transformPx2Rem(customFeature.secFontSize, 320),
          fontWeight: customFeature.secFontWeight || 'nomal',
          fontStyle: customFeature.secFontStyle || 'normal',
          textDecoration: customFeature.secTextDecoration || 'none',
          color: customFeature.secColor || ''
        };
      }
      newdata['eles[' + compindex + '].classifyItemStyle'] = classifyItemStyle;
      newdata['eles[' + compindex + '].listIconStyle'] = listIconStyle;
      newdata['eles[' + compindex + '].imgStyle'] = imgStyle;
      newdata['eles[' + compindex + '].textStyle'] = textStyle;
    }

    if (customFeature.vesselAutoheight == 1 || customFeature.vesselAutoheight == 2) {
      newdata['eles[' + compindex + '].customFeature.height'] = 'auto';
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].list_data'] = [];
    newdata['eles[' + compindex + '].is_more'] =1;
    // WEBAPP不存在顶部导航
    if (pageInstance.data.page_hasNavBar){
      newdata['eles[' + compindex + '].topNavBarHeight'] = app.globalData.topNavBarHeight;
      newdata['eles[' + compindex + '].page_hasNavBar'] = true;
    }else{
      newdata['eles[' + compindex + '].topNavBarHeight'] = 0;
      newdata['eles[' + compindex + '].page_hasNavBar'] = false;
    }
    pageInstance.setData(newdata);

    if (compData.classifyType === 'level2-vertical-withpic') {
      _this.dynamicSetBoundingClientRectInfo(pageInstance, compindex);
    }

    if (customFeature.classifyType == 2) { // 自定义分类
      _this.initDynamicClassifyEle(pageInstance, compindex, customFeature.classifyList, {}, compData);
    }else { // 非自定义分类
      if (cateParam.group_id == '') { // 选择 '无'
        app.showToast({
          title: '动态分类组件未绑定分类组',
          icon: 'none'
        });
      }else {
        if (cateParam.group_id == -1) { // 选择 '全部'
          cateReqUrl = '/index.php?r=AppData/ListCategory';
          if (['goods', 'appointment', 'waimai', 'tostore'].indexOf(customFeature.form) > -1) {
            cateParam = {
              form: 'goods',
              goods_type: util.getGoodsTypeByForm(customFeature.form)
            }
          }else {
            cateParam = {
              form: customFeature.form
            }
          }
        }
        app.sendRequest({
          hideModal: true,
          hideLoading: true,
          url: cateReqUrl,
          data: cateParam,
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function(res){
            _this.initDynamicClassifyEle(pageInstance, compindex, (res.data.item || res.data), cateParam, compData);
          },
          fail: function (res) {
            let newdata = {};
            newdata['eles[' + compindex + '].loadingFail'] = true;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          },
          hideTemplateLoading: function() {
            let newdata = {};
            newdata['eles[' + compindex + '].loading'] = false;
            newdata['eles[' + compindex + '].is_more'] = 0;
            newdata['eles[' + compindex + '].list_data'] = [];
            pageInstance.setData(newdata);
          }
        });
      }
    }
    if (compData.customFeature.topHover){
      compData.classify_observer && compData.classify_observer.disconnect();
      this.topHover(pageInstance, compindex);
    }
    if (compData.customFeature.topHover) {
      compData.list_observer && compData.list_observer.disconnect();
      this.bottomHover(pageInstance, compindex);
    }
  }

  // 初始化动态分类组件
  initDynamicClassifyEle = (pageIns, compindex, cateData, cateParam, compData) => {
    let _this = this;
    let pageInstance = pageIns || app.getAppCurrentPage();
    let classifyLevel = compData.classifyType.charAt(5);
    let classifyData = [];
    let newData = {};
    let currentCategory = [];
    if (cateParam.group_id) {
      classifyData = cateData;
      if (compData.classifyType === 'level1-vertical-withpic' || compData.classifyType === 'level2-vertical-withpic') { // 设置默认图片
        classifyData.forEach(function (item) {
          item.cover = /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(item.cover) ? item.cover : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png';
          item.subclass.forEach(function (sitem) {
            sitem.cover = /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(sitem.cover) ? sitem.cover : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png';
          })
        });
      }
    }else { // 处理默认选择全部分类的情况
      classifyData = cateData.map(function (item) {
        return {
          category_id: item.id,
          group_id: '',
          name: item.name,
          cover: /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(item.logo) ? item.logo : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
          pid: 0,
          weight: item.weight || '',
          subclass: item.subclass && item.subclass.map(function (sitem) {
            return {
              category_id: sitem.id,
              group_id: '',
              name: sitem.name,
              cover: /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(sitem.logo) ? sitem.logo : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
              pid: item.id,
              weight: sitem.weight || ''
            }
          }) || []
        }
      });
      if ((!compData.customFeature.classifyType || compData.customFeature.classifyType == 1) && !compData.customFeature.showAllClassify) { // 非自定义分类显示全部分类
        classifyData.unshift({
          category_id: '',
          group_id: '',
          name: '全部',
          cover: 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
          pid: 0,
          weight: '',
          subclass: []
        });
      }
    }

    if (compData.classifyType == 'level2-vertical-withpic' || compData.customFeature.showAllClassify) { // 过滤分类中的全部分类
      classifyData = classifyData.filter(function(item){
        return item.category_id;
      });
    }

    if(classifyLevel == 1 && classifyData[0]){
      currentCategory.push(classifyData[0]['category_id']);
    } else if (classifyLevel == 2 && classifyData[0]){

      currentCategory = [ classifyData[0]['category_id'], classifyData[0]['category_id']];

      if (!compData.customFeature.showAllClassify && compData.classifyType !== 'level2-vertical-withpic') { // 二级是否显示全部
        classifyData.forEach(function (item) {
          if (item.name === '全部') {
            return;
          }
          item.subclass.unshift({
            category_id: item.category_id,
            group_id: item.group_id,
            name: '全部',
            cover: 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
            pid: 0,
            weight: item.weight
          });
        });
      }else if (classifyData[0].subclass[0]) {
        currentCategory[1] = classifyData[0].subclass[0]['category_id'];
      };
    }
    newData['eles[' + compindex + '].customFeature.selected'] = 0;
    newData['eles[' + compindex + '].classifyData'] = classifyData;
    newData['eles[' + compindex + '].classifyGroupForm'] = compData.customFeature.form;
    newData['eles[' + compindex + '].currentCategory'] = currentCategory;
    pageInstance.setData(newData);
    if (classifyLevel == 1 && currentCategory.length < 1) {
      return;
    } else if (classifyLevel == 2 && currentCategory.length < 2) {
      if (currentCategory.length == 1){
        currentCategory[1] = currentCategory[0];
      } else {
        return;
      }
    }
    if(compData.classifyType == 'level2-vertical-withpic'){
      return;
    }
    let idx_value = currentCategory[classifyLevel - 1] == -1 ? '' : currentCategory[classifyLevel - 1];
    let param = {
      page: 1,
      page_size: compData.customFeature.loadingNum || 10,
      form: compData.customFeature.form,
      idx_arr: {
        idx: 'category',
        idx_value: idx_value
      }
    };
    param.page_size = compData.customFeature.loadingNum || 10;
    let field = app.getListVessel(compData);
    let fieldData = {};
    fieldData['eles[' + compindex + '].listField'] = field;
    pageInstance.setData(fieldData);

    app.sendRequest({
      hideLoading: true,   // 页面第一个请求才展示loading
      url: '/index.php?r=AppData/getFormDataList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newdata = {};
        if (param.form !== 'form') { // 动态列表绑定表单则不调用富文本解析
          for (let j in res.data) {
            for (let k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if(/region/.test(k)){
                continue;
              }
              if(k == 'goods_model') {
                res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
              }
              if (k == 'distance') {
                res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
              }
              let description = res.data[j].form_data[k];
              if (field.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
                res.data[j].form_data[k] = '';
              } else if (app.needParseRichText(description)) {
                res.data[j].form_data[k] = app.getWxParseResult(description);
              }
            }
          }
        }
        newdata['eles[' + compindex + '].list_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more || '';
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newdata);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  // 动态分类设置节点信息
  dynamicSetBoundingClientRectInfo = (pageIns, compindex, n) => {
    if (!compindex || compindex === -1) {
      return;
    }
    let that = this,
      pageInstance = pageIns || app.getAppCurrentPage(),
      winHeight = '100%',
      newData = {};
    app.getBoundingClientRect('.sub-classify-area', function(areaRect) {
      if (!areaRect.length) {
        if (isNaN(n)) {
          n = 0;
        }
        if (n < 10) {
          setTimeout(function () {
            that.dynamicSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
        }
        return;
      }
      winHeight = areaRect.shift().height;
      newData['eles[' + compindex + '].SCAOffHeight'] = winHeight;
      app.getBoundingClientRect('.sub-classify-item-list', function (itemRects) {
        if (!itemRects.length && (isNaN(n) || n < 10)) {
          if (isNaN(n)) {
            n = 0;
          }
          setTimeout(function () {
            that.dynamicSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
          return;
        }
        let offsetArr = [];
        let baseHeight = 0;
        if (pageInstance.data.eles[compindex].customFeature.showActiveImage && pageInstance.data.eles[compindex].customFeature.activeImage) {
          baseHeight = parseInt(pageInstance.data.eles[compindex].classifyStyle.classifyImgHeight) * 2.34375 / app.globalData.systemInfo.rpxRatio + parseInt(20 / app.globalData.systemInfo.rpxRatio)
        }
        itemRects.map(rect => rect.height).reduce(function (p, c) {
          offsetArr.push(p);
          return p + c;
        }, baseHeight);

        newData['eles[' + compindex + '].SCILOffsetTopArr'] = offsetArr;

        if (itemRects.length) { // 滚动区域最小高度
          newData['eles[' + compindex + '].SCAMinHeight'] = itemRects.pop().top + winHeight + 'px';
        }
        pageInstance.setData(newData);
      })
    })
  }

  // 动态分类: 点击不同分类对应的数据
  tapDynamicClassifyFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let level = event.currentTarget.dataset.level;
    let categoryId = event.currentTarget.dataset.categoryId;
    let hideSubclass = event.currentTarget.dataset.hideSubclass;
    let hasSubclass = event.currentTarget.dataset.hasSubclass;
    let cateIndex = event.currentTarget.dataset.index;
    let compData = pageInstance.data.eles[compindex];
    let currentClassifyLevel = compData.classifyType.charAt(5);
    let showClassifySelect = compData.showClassifySelect;
    let sortKey = compData.sort_key === undefined ? '' : compData.sort_key;
    let sortDirection = compData.sort_direction === undefined ? '' : compData.sort_direction;
    let newData = {};
    if (showClassifySelect) {
      newData['eles[' + compindex + '].showClassifySelect'] = false;
    }
    if (hideSubclass == 1) {
      newData['eles[' + compindex + '].classifyAreaLevel2Show'] = false;
      pageInstance.setData(newData);
      return;
    }
    if (currentClassifyLevel == 2) {
      if (categoryId == '') {
        compData.currentCategory[0] = categoryId;
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = false;
      } else if (compData.currentCategory[level - 1] == categoryId) {
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = hasSubclass ? !compData['classifyAreaLevel2Show'] : false;;
      } else if(level == 1) {
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = hasSubclass ? true : false;
      } else if (level == 2) {
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = false;
      }
    }
    compData.currentCategory[level - 1] = categoryId;
    newData['eles[' + compindex + '].currentCategory'] = compData.currentCategory;
    // 隐藏遮罩层
    newData['eles[' + compindex + '].showAllSubclassifySelect'] = false;
    pageInstance.setData(newData);
    if(compData.classifyType == 'level1-vertical-withpic'){
      app.turnToPage('/pages/classifyGoodsListPage/classifyGoodsListPage?form=' + compData.classifyGroupForm + '&category_id=' + categoryId, false);
      return;
    }
    if(compData.classifyType == 'level2-vertical-withpic'){
      if(level == 2){
        app.turnToPage('/pages/classifyGoodsListPage/classifyGoodsListPage?form=' + compData.classifyGroupForm + '&category_id=' + categoryId, false);
      }
      if (level == 1) {
        if (compData.customFeature.scrollChangeClassify){
          let SCILOffsetTopArr = compData.SCILOffsetTopArr || [];
          pageInstance.setData({
            ['eles[' + compindex + '].SCAScrollTop']: SCILOffsetTopArr[cateIndex],
            ['eles[' + compindex + '].isSCATap']: true
          });
        } else {  // 点击切换分类哦
          let setStr = 'eles[' + compindex + '].customFeature.selected';
          pageInstance.setData({ [setStr]: cateIndex });
        }
      }
      return;
    }
    if (currentClassifyLevel != level && hasSubclass) { // 点击非最后一级的分类不请求新数据
      if (level == 1 && compData.classifyType == 'level2-vertical-nopic') {
        categoryId = event.currentTarget.dataset.subclassId;
        compData.currentCategory[1] = event.currentTarget.dataset.subclassId;
        pageInstance.setData({ ['eles[' + compindex + '].currentCategory']: compData.currentCategory});
      }else{
        return
      }
    }

    newData = {};
    if (compData.classifyType == 'level1-horizontal' && compData.classifyStyle.mode == 2) {
      if (cateIndex && cateIndex > 3) {
        newData['eles[' + compindex + '].CAScrollLeft'] = 150 * (cateIndex - 3) + 'rpx';
      }else {
        newData['eles[' + compindex + '].CAScrollLeft'] = 0;
      }
    }
    newData['eles[' + compindex + '].loading'] = true;
    newData['eles[' + compindex + '].loadingFail'] = false;
    newData['eles[' + compindex + '].list_data'] = [];
    newData['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(newData);

    // 根据groupId请求第一个分类绑定的数据
    let param = {
      page: 1,
      page_size: 10,
      form: compData.classifyGroupForm,
      idx_arr: {
        idx: 'category',
        idx_value: categoryId == -1 ? '' : categoryId
      },
      sort_key: sortKey,
      sort_direction: sortDirection
    };
    param.page_size = compData.customFeature.loadingNum || 10;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppData/getFormDataList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newdata = {};
        if (param.form !== 'form') { // 动态列表绑定表单则不调用富文本解析
          for (let j in res.data) {
            for (let k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if(/region/.test(k)){
                continue;
              }
              if(k == 'goods_model') {
                res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
              }
              if (k == 'distance') {
                res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
              }

              let description = res.data[j].form_data[k];
              let listField = compData.listField;
              if (listField && listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
                res.data[j].form_data[k] = '';
              } else if (app.needParseRichText(description)) {
                res.data[j].form_data[k] = app.getWxParseResult(description);
              }
            }
          }
        }
        newdata['eles[' + compindex + '].list_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newdata);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  // 动态分类：点击下拉选择
  tapDynamicShowAllClassify = (event) => {
    let dataset = event.currentTarget.dataset,
      compindex = dataset.compindex,
      pageInstance = app.getAppCurrentPage(),
      compData = pageInstance.data.eles[compindex],
      showClassifyAll = compData.showClassifySelect;

    pageInstance.setData({
      ['eles[' + compindex + '].showClassifySelect']: !showClassifyAll
    });
  }

  // 动态分类二级分类列表的滚动事件
  dynamicSubClassifyAreaScrollEvent = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let offsetTopArr = JSON.parse(dataset.offsetTopArr);
    let { scrollTop } = event.detail;

    if (pageInstance.data.eles[compindex].isSCATap) {
      pageInstance.setData({
        ['eles[' + compindex + '].isSCATap']: false
      });
      return;
    }

    offsetTopArr = offsetTopArr || []; // WEBAPP
    for (let i = 0, l = offsetTopArr.length; i < l; i++) {
      if (Math.abs(scrollTop - offsetTopArr[i]) < 50) {
        let classifyData = pageInstance.data.eles[compindex].classifyData;
        if (!classifyData[i]) {
          return;
        }
        pageInstance.setData({
          ['eles[' + compindex + '].currentCategory[0]']: classifyData[i].category_id
        });
        return;
      }
    }
  }

  bindEventTapHandler = (e) => {
    let form = JSON.parse(e.currentTarget.dataset.eventparams);
    let action = form.action;
    customEvent.clickEventHandler[action] && customEvent.clickEventHandler[action](form);
  }

  // 顶部悬停
  topHover = (pageInstance, compindex) => {
    let compData = pageInstance.data.eles[compindex];
    compData.classify_observer = new IntersectionObserver(([res]) => {
      if (!res) {
        return;
      }
      if (res.boundingClientRect.top < 0 && res.intersectionRect.top == 0){
        pageInstance.setData({
          ['eles[' + compindex + '].topHover']: res.intersectionRatio == 1 ? false : true
        })
      }else {
        pageInstance.setData({
          ['eles[' + compindex + '].topHover']: false 
        })
      }
    });
    let top = 0;
    if (pageInstance.data.page_hasNavBar) { //WEBAPP
      top = 0 - app.globalData.topNavBarHeight;
    }
    setTimeout(() => {
      let $customComponent = document.getElementsByClassName('custom-page')[0].children[this.props.index];
      let $topHover = $customComponent.getElementsByClassName('topHover')[0];
      compData.classify_observer.observe($topHover)
      // compData.classify_observer.relativeToViewport({top: top}).observe($topHover)
    }, 0);
  }

  //监控列表是否离开视口
  bottomHover = (pageInstance, compindex) => { 
    let compData = pageInstance.data.eles[compindex];
    compData.list_observer = new IntersectionObserver(([res]) => {
      if (!(res.intersectionRatio > 0) && res.boundingClientRect.top < 0) {
        pageInstance.setData({
          ['eles[' + compindex + '].topHover']: false
        })
      }
    });
    setTimeout(() => {
      let $customComponent = document.getElementsByClassName('custom-page')[0].children[this.props.index];
      let $bottomHover = $customComponent.getElementsByClassName('bottomHover')[0];
      compData.list_observer.observe($bottomHover)
    }, 0);
  }

  showAllSubclassify = (event) => {
    let dataset = event.currentTarget.dataset,
        pageInstance = app.getAppCurrentPage(),
        compindex = dataset.compindex,
        compData = pageInstance.data.eles[compindex];
    pageInstance.setData({
      ['eles[' + compindex + '].showAllSubclassifySelect']: !compData.showAllSubclassifySelect
    });
  }

  //隐藏蒙层
  hideCover = (event) => {
    let dataset = event.currentTarget.dataset,
      pageInstance = app.getAppCurrentPage(),
      compindex = dataset.compindex,
      compData = pageInstance.data.eles[compindex];
    pageInstance.setData({
      ['eles[' + compindex + '].classifyAreaLevel2Show']: false,
      ['eles[' + compindex + '].showClassifySelect']: false
    });
  }

  listVesselTurnToPage = (event) => {
    app.listVesselTurnToPage(event)
  }
  
  pageScrollFunc = (event) => {
    app.pageScrollFunc(event);
  }

  render(){
    const data = this.props.data;
    const classifyType = data.classifyType;
    let styleObj = convertStyleData(data.style);
    const content = data.content;
    // 是否有底部导航
    const isTabBarPage = app.isTabBarPage();
    /**
     * 加载状态/点击按钮
     */
    const Others = () => {
      return (
        <React.Fragment>
          {/* 加载loading */}
          {
            data.loading && 
            <RequestStatus is="requestLoading" ></RequestStatus>
          }
          {/* 加载没有数据 */}
          {
            data.is_more == 0 && data.list_data.length == 0 && 
            <RequestStatus is="requestNone" data={{ data: '暂无数据~'}} ></RequestStatus>
          }
          {/* 加载失败 */}
          {
            !!data.loadingFail &&
            <RequestStatus is="requestFail" data={{refreshEvent: 'pageScrollFunc', compindex: this.props.index}} ></RequestStatus>
          }
          {/* 加载完所有数据（小程序竖版没有加isShowFinishText判断） */}
          {
            data.is_more == 0 && data.list_data.length > 0 && data.customFeature.isShowFinishText &&
            <RequestStatus is="requestAll" ></RequestStatus>
          }
          {/* 点击加载按钮 */}
          {
            (data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.is_more == 1 && !data.isLoading && !data.loadingFail) &&
            <LoadingBtn customFeature={data.customFeature} onClick={this.pageScrollFunc} data-compindex={this.props.index}></LoadingBtn>
          }
        </React.Fragment>
      )
    }

    // 一级横版
    const $level1Horizontal = () => {
      styleObj = {...styleObj, ...{
        height: 'auto',
        backgroundColor: data.vesselStyle['background-color'],
        backgroundImage: data.vesselStyle['background-image'],
      }};
      const $dynamicClassifyItemList = (data) => {
        return data.classifyData && data.classifyData.map((item, index) => (
          <React.Fragment key={index}>
            {
              item.category_id == data.currentCategory[0] ?
                (
                  <div className="dynamic-classify-item selected" style={{color:data.classifyStyle.selectedColor,height:'100%'}}
                        onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                        data-level="1"
                        data-category-id={item.category_id}
                        data-compindex={this.props.index}
                        data-index={index}>
                    {
                      data.classifyStyle.mode == 0 && (
                        <span style={{fontSize:data.classifyStyle.selectedFontSize,fontStyle:data.classifyStyle.selectedFontStyle,fontWeight:data.classifyStyle.selectedFontWidget,textDecoration:data.classifyStyle.selectedTextDecoration,backgroundColor:data.classifyStyle.selectedColor}}>{item.name}</span>
                      )
                    }
                    {
                      data.classifyStyle.mode == 1 && (
                        <span style={{color:data.classifyStyle.selectedColor,fontSize:data.classifyStyle.selectedFontSize,fontStyle:data.classifyStyle.selectedFontStyle,fontWeight:data.classifyStyle.selectedFontWidget,textDecoration:data.classifyStyle.selectedTextDecoration}}>{item.name}</span>
                      )
                    }
                    {
                      data.classifyStyle.mode == 2 && (
                        <span style={{fontSize:data.classifyStyle.selectedFontSize,fontStyle:data.classifyStyle.selectedFontStyle,fontWeight:data.classifyStyle.selectedFontWidget,textDecoration:data.classifyStyle.selectedTextDecoration}}>{item.name}</span>
                      )
                    }
                    {
                      !!data.classifyStyle.isShowUnderLine && (
                        <i className="underline" style={{background:data.classifyStyle.selectedColor,width:data.classifyStyle.underLineWidth}}></i>
                      )
                    }
                  </div>
                )
                :
                (
                  <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                    data-level="1"
                    data-category-id={ item.category_id }
                    data-compindex={this.props.index}
                    data-index={index}>
                    <span>{item.name}</span>
                  </div>
                )
            }
          </React.Fragment>
        ))
      }
      return (
        <div
          className="element dynamic-classify type-level1-horizontal"
          style={{...styleObj,height:'auto',backgroundColor:data.vesselStyle['background-color'],backgroundImage:data.vesselStyle['background-image']}}
          // bindanimationend="animationEnd"
          data-compindex={this.props.index}>
          <div className={data.customFeature.topHover ? 'topHover' : ''} style={{height:'.02rem'}}></div>
          <div className={`fixed ${data.topHover ? 'hover' : ''}`} style={{width:'100%',top: (data.topNavBarHeight || 0)+'px'}}>
            {
              data.classifyStyle.mode == 2 && (
                <div className="classify-area-open-btn"
                  style={{backgroundColor:data.classifyStyle['background-color'],height:data.classifyStyle['height'],lineHeight:data.classifyStyle['line-height'],opacity:data.classifyStyle['opacity']}}
                  >
                  {
                    (data.customFeature.horizontalImageSrc && DynamicClassifyModule.isImage(data.customFeature.horizontalImageSrc,'dynamic-classify') >= 0) && (
                      <span className={`ico-moon icon-${data.customFeature.horizontalImageSrc || 'dynamic-classify1'}`} onClick={(e) => {this.tapDynamicShowAllClassify(e);e.stopPropagation()}} data-compindex={this.props.index}></span>
                    )
                  }
                  {
                    (data.customFeature.horizontalImageSrc && DynamicClassifyModule.isImage(data.customFeature.horizontalImageSrc,'dynamic-classify') < 0) && (
                      <img onClick={(e) => {this.tapDynamicShowAllClassify(e);e.stopPropagation()}} data-compindex={this.props.index} src={data.customFeature.horizontalImageSrc}/>
                    )
                  }
                </div>
              )
            }
            <ScrollView className={`classify-area mode-${ data.classifyStyle.mode }`} scroll-x={true}
              style={{lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height'],backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],textDecoration:data.classifyStyle['text-decoration'],color:data.classifyStyle['color'],width:data.classifyStyle.mode == 2 ? 'calc(100% - 75rpx - 30rpx)' : ''}}
              scroll-left={data.CAScrollLeft}
              >
              <div className={`classify-area-main mode-${ data.classifyStyle.mode }`}>
                {
                  $dynamicClassifyItemList(data)
                }
              </div>
            </ScrollView>
            {
              data.classifyStyle.mode == 2 && (
                <div>
                  <div hidden={!data.showClassifySelect} className='classify-mode2'>
                    <div className="classify-area-main mode-2" style={{height:'100%'}}>
                      {
                        $dynamicClassifyItemList(data)
                      }
                    </div>
                  </div>
                </div>
              )
            }
          </div>
          <ScrollView className={`vessel-area scroll-ele ${ data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode: ''}`}
            data-compindex={this.props.index}
            scroll-y={true}
            lower-threshold="100"
            data-curpage={data.curpage}
            bindscrolltolower={this.pageScrollFunc}
            style={{opacity:data.vesselStyle['opacity'],marginTop:data.vesselStyle['margin-top'],height:data.customFeature.height}}
            >
            <div className="js-list-container" data-list-index="0" style={{minHeight: data.is_more == 1 ? '' : 'auto'}}>
              {
                data.list_data && data.list_data.map((item, index) => (
                  <div
                    key={index} 
                    className={`list-vessel clearfix ${data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : ''} background-ele`}
                    style={{backgroundColor:data.vesselStyle['lineBackgroundColor'],backgroundImage:data.vesselStyle['lineBackgroundImage'],marginBottom:data.vesselStyle['margin']+'px'}}
                    data-dataid={data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : (item.id || item.form_data.id)}
                    data-router={data.customFeature.link}
                    data-compindex={this.props.index}
                    data-index={index}
                    data-isseckill={(item.form_data.is_seckill && item.form_data.is_seckill) || ''}
                    onClick={(e) => {this.listVesselTurnToPage(e);e.stopPropagation()}}
                    >
                    {content.map((componentData, componentIndex) => 
                      <CustomComponent key={componentIndex} index={componentIndex} data={componentData} dynamicData={item['form_data']}/>
                    )}
                  </div>
                ))
              }
            </div>
            {/* 加载状态/点击按钮 */}
            <Others></Others>
            {
              !!(data.classifyStyle.mode == 2 && data.showClassifySelect) && (
                <div className='dynamic-classify-cover' onClick={this.hideCover} data-compindex={this.props.index}>
                  <div className='dynamic-classify-cover'></div>
                </div>
              )
            }
          </ScrollView>
          <div className={data.customFeature.topHover ? 'bottomHover' : ''} style={{height: '0.02rem'}}></div>
        </div>
      )
    }
    // 一级竖版
    const $level1Vertical = () => {
      return (
        <div
          className="element dynamic-classify type-level1-vertical"
          style={{...styleObj,height:data.customFeature.autoHeight == 1 ? `calc(100vh - ${isTabBarPage ? '48px': '0'})` : ''}}
          // bindanimationend="animationEnd"
          data-compindex={this.props.index}>
          <ScrollView className={`classify-area mode-${ data.classifyStyle.mode }`}
            scroll-y={true}
            style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],textDecoration:data.classifyStyle['text-decoration'],color:data.classifyStyle['color']}}
            >
            {
              data.classifyData && data.classifyData.map((item, index) => (
                <React.Fragment key={index}>
                  {
                    item.category_id == data.currentCategory[0] ? 
                      (
                        <div className="dynamic-classify-item selected"
                          style={{backgroundColor:data.classifyStyle.selectedBackgroundColor,color:data.classifyStyle.selectedColor,height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                          onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                          data-level="1"
                          data-category-id={ item.category_id }
                          data-compindex={this.props.index}>
                          {
                            !!+(item.category_id && item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                          <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                          {
                            !!+(item.category_id && item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                          <i className="leftline" style={{borderColor:data.classifyStyle.selectedColor}} ></i>
                        </div>
                      )
                      :
                      (
                        <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                              style={{height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                              data-level="1"
                              data-category-id={ item.category_id }
                              data-compindex={this.props.index}>
                          {
                            !!+(item.category_id && item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                          <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                          {
                            !!+(item.category_id && item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                        </div>
                      ) 
                  }
                </React.Fragment>
              ))
            }
          </ScrollView>
          < ScrollView className={`vessel-area scroll-ele ${ data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode: ''}`}
            data-compindex={this.props.index}
            scroll-y={true}
            lower-threshold="100"
            data-curpage={data.curpage}
            bindscrolltolower={this.pageScrollFunc}
            style={{left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),width:`calc(100% - ${ DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])})`,opacity:data.vesselStyle['opacity'],marginTop:data.vesselStyle['margin-top']}}
            >
            {/* 排序组件 */}
            {
              !!(data.customFeature.showActiveImage && data.currentCategory && data.currentCategory[0] == data.classifyData[0].category_id) && (
                <div className="active-image">
                  <img src={data.customFeature.activeImage} onClick={this.bindEventTapHandler} data-eventparams={JSON.stringify(data.customFeature)}
                    style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth),height:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight),borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius'])}}/>
                </div>
              )
            }
            <div className="js-list-container" data-list-index="0" style={{minHeight: data.is_more == 1 ? '' : 'auto',backgroundColor:data.vesselStyle['background-color'],backgroundImage:data.vesselStyle['background-image']}}>
              {
                data.list_data && data.list_data.map((item, index) => (
                  <div
                    key={index}
                    className={`list-vessel clearfix ${data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : ''} background-ele`}
                    style={{backgroundColor:data.vesselStyle['lineBackgroundColor'],backgroundImage:data.vesselStyle['lineBackgroundImage'],marginBottom:data.vesselStyle['margin']+'px'}}
                    data-dataid={data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : (item.id || item.form_data.id)}
                    data-router={data.customFeature.link}
                    data-compindex={this.props.index}
                    data-index={index}
                    data-isseckill={(item.form_data.is_seckill && item.form_data.is_seckill) || ''}
                    onClick={(e) => {this.listVesselTurnToPage(e);e.stopPropagation()}}
                    >
                    {content.map((componentData, componentIndex) => 
                      <CustomComponent key={componentIndex} index={componentIndex} data={componentData} dynamicData={item['form_data']}/>
                    )}
                  </div>
                ))
              }
            </div>
            {/* 加载状态/点击按钮 */}
            <Others></Others>
          </ScrollView>
        </div>
      )  
    }
    // 一级竖版带图
    const $level1VerticalWithpic = () => {
      return (
        <div className="element dynamic-classify type-level1-vertical-withpic"
          style={ styleObj }
          bindanimationend="animationEnd"
          data-compindex={this.props.index}>
          <div className={`classify-area large-picture-style ${data.customFeature.structure == 2 ? 'horizontal-style' : ''}`}
            style={{marginTop:data.classifyStyle['margin-top'],backgroundImage:data.classifyStyle['backgroundImage'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],color:data.classifyStyle['color'],}}
          >
          {
            data.customFeature.showAllClassify && (
              <div className="dynamic-classify-item"
                    style={{...data.classifyItemStyle}}
                    onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                    data-level="1"
                    data-compindex={this.props.index}
                    data-category-id="0">
                {
                  !!+(!data.customFeature.showClassifyIcon && data.customFeature.showAllClassifyImageSrc && DynamicClassifyModule.isImage(data.customFeature.showAllClassifyImageSrc,'showclassify') >= 0) && (
                    <i className={`ico-moon icon-${data.customFeature.showAllClassifyImageSrc || 'showclassify1'}`} style={{borderRadius:DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius),...data.imgStyle,fontStyle:'normal'}}></i>
                  )
                }
                {
                  !!+(!data.customFeature.showClassifyIcon && data.customFeature.showAllClassifyImageSrc && DynamicClassifyModule.isImage(data.customFeature.showAllClassifyImageSrc,'showclassify') < 0) && (
                    <img style={{borderRadius:DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius),...data.imgStyle}} mode="scaleToFill" src={data.customFeature.showAllClassifyImageSrc}/>
                  )
                }
                <span style={{...data.textStyle}}>全部</span>
              </div>
            )
          }
          {
            data.classifyData && data.classifyData.map((item, index) => (
              <React.Fragment key={index}>
                {
                  !!+(item.category_id || data.customFeature.showAllClassify) && (
                    <div className="dynamic-classify-item"
                          style={{...data.classifyItemStyle}}
                          onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                          data-level="1"
                          data-category-id={ item.category_id }
                          data-compindex={this.props.index}>
                      {
                        !data.customFeature.showClassifyIcon && (
                          <img style={{borderRadius:DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius),...data.imgStyle}} mode="scaleToFill" src={item.cover}/>
                        )
                      }
                      <span style={{...data.textStyle}}>{item.name}</span>
                    </div>
                  )
                }
              </React.Fragment>
            ))
          }
          </div>
        </div>
      )
    }
    // 二级横版
    const $level2Horizontal = () => {
      return (
        <div
          className="element dynamic-classify type-level2-horizontal"
          style={{...styleObj,height:'auto',backgroundImage:data.vesselStyle['background-image'],backgroundColor:data.vesselStyle['background-color']}}
          // bindanimationend="animationEnd"
          data-compindex={this.props.index}
          >
          <div className={data.customFeature.topHover ? 'topHover' : ''} style={{height:'.02rem'}}></div>
          <div className={`fixed ${data.topHover ? 'hover' : ''}`} style={{width:'100%',top:data.topNavBarHeight+'px'}}>
            <ScrollView className={`classify-area mode-${ data.classifyStyle.mode }`} scroll-x={true}
              style={{lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height'],backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],textDecoration:data.classifyStyle['text-decoration'],color:data.classifyStyle['color']}}
              >
              {
                data.classifyData && data.classifyData.map((item, index) => (
                  <React.Fragment key={index}>
                    {
                      item.category_id == '' ? 
                        (
                          <React.Fragment>
                            {
                              item.category_id == data.currentCategory[0] ?
                                (
                                  <div className="dynamic-classify-item selected" style={{color:data.classifyStyle.selectedColor}}
                                    onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                    data-level="2"
                                    data-category-id={ item.category_id }
                                    data-compindex={this.props.index}>
                                    <span style={{textDecoration:data.classifyStyle['text-decoration']}}>全部</span>
                                    {
                                      index != data.classifyData.length - 1 && (
                                        <i className="divide-line" style={{backgroundColor: data.classifyStyle.divideLineColor }}></i>
                                      )
                                    }
                                  </div>
                                )
                                :
                                (
                                  <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                        data-level="2"
                                        data-category-id={ item.category_id }
                                        data-compindex={this.props.index}>
                                    <span style={{textDecoration:data.classifyStyle['text-decoration']}}>全部</span>
                                    {
                                      index != data.classifyData.length - 1 && (
                                        <i className="divide-line" style={{backgroundColor: data.classifyStyle.divideLineColor }}></i>
                                      )
                                    }
                                  </div>
                                )
                            }
                          </React.Fragment>
                        )
                        :
                        (
                          <React.Fragment>
                            {
                              item.category_id == data.currentCategory[0] ?
                                (
                                  <div className="dynamic-classify-item selected" style={{color:data.classifyStyle.selectedColor}}
                                        onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                        data-level="1"
                                        data-category-id={ item.category_id }
                                        data-compindex={this.props.index}
                                        data-has-subclass={item.subclass && item.subclass.length}>
                                    <span style={{textDecoration:data.classifyStyle['text-decoration']}}>{item.name}</span>
                                    {
                                      data.classifyStyle.mode == 0 && (
                                        <i className="triangle" style={{borderTop:`.10rem solid ${data.classifyStyle.selectedColor}`}}></i>
                                      )
                                    }
                                    {
                                      data.classifyStyle.mode == 1 && (
                                        <i className="triangle" style={{borderColor:data.classifyStyle.selectedColor}}></i>
                                      )
                                    }
                                    {
                                      index != data.classifyData.length - 1 && (
                                        <i className="divide-line" style={{backgroundColor: data.classifyStyle.divideLineColor }}></i>
                                      )
                                    }
                                  </div>
                                )
                                :
                                (
                                  <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                    data-level="1"
                                    data-category-id={ item.category_id }
                                    data-compindex={this.props.index}
                                    data-has-subclass={item.subclass && item.subclass.length}>
                                    <span style={{textDecoration:data.classifyStyle['text-decoration']}}>{ item.name }</span>
                                    <i className="triangle" ></i>
                                    {
                                      index != data.classifyData.length - 1 && (
                                        <i className="divide-line" style={{backgroundColor: data.classifyStyle.divideLineColor }}></i>
                                      )
                                    }
                                  </div>
                                )
                            }
                          </React.Fragment>
                        )
                    }
                  </React.Fragment>
                ))
              }
            </ScrollView>
            <ScrollView className="sub-classify-area"
              hidden={ !data.classifyAreaLevel2Show }
              onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
              data-hide-subclass="1"
              data-compindex={this.props.index}
              scroll-y={true}
              style={{top: data.classifyStyle['height']}}>
              {
                data.classifyData && data.classifyData.map((item, index) => (
                  <React.Fragment key={index}>
                    {
                      !data.customFeature.level2ClassifyStyle && (
                        <div className="sub-classify-item-list"
                          hidden={ item.category_id != data.currentCategory[0] }
                          style={{backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity: data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight: data.classifyStyle['font-weight'],fontStyle: data.classifyStyle['font-style'],textDecoration: data.classifyStyle['text-decoration'],color:data.classifyStyle['color']}}
                          >
                          {
                            item.subclass && item.subclass.map((subItem, subIndex) => (
                              <React.Fragment key={subIndex}>
                                {
                                  subItem.category_id == data.currentCategory[1] ?
                                    (
                                      <div className="sub-classify-item selected"
                                        onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                        data-level="2"
                                        data-category-id={ subItem.category_id }
                                        data-compindex={this.props.index}
                                        style={{color:data.classifyStyle.selectedColor,lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height']}}>
                                        <span style={{textDecoration:data.classifyStyle['text-decoration']}}>{subItem.name}</span>
                                        <i className="ico-moon icon-gou"></i>
                                      </div>
                                    )
                                    :
                                    (
                                      <div className="sub-classify-item"
                                        onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                        data-level="2" data-category-id={ subItem.category_id }
                                        data-compindex={this.props.index}
                                        style={{lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height'],textDecoration:data.classifyStyle['text-decoration']}}>{ subItem.name }</div>
                                    )
                                }
                              </React.Fragment>
                            ))
                          }
                        </div>
                      )
                    }
                    {
                      !!+data.customFeature.level2ClassifyStyle && (
                        <div className="sub-classify-item-list-mode2"
                          hidden={ item.category_id != data.currentCategory[0] }
                          style={{backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],textDecoration:data.classifyStyle['text-decoration'],color:data.classifyStyle['color']}}>
                          {
                            item.subclass && item.subclass.map((subItem, subIndex) => (
                              <React.Fragment key={subIndex}>
                                {
                                  subItem.category_id == data.currentCategory[1] ?
                                    (
                                      <div className="sub-classify-item-mode2 selected"
                                        onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                        data-level="2"
                                        data-category-id={ subItem.category_id }
                                        data-compindex={this.props.index}
                                        style={{color:data.classifyStyle.selectedColor,borderColor:data.classifyStyle.selectedColor,lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height'],flex:`0 0 calc(${ 100/data.customFeature.level2ClassifyColumn + '% - .30rem'})`,textDecoration:data.classifyStyle['text-decoration']}}>
                                          {subItem.name}
                                        </div>
                                    )
                                    :
                                    (
                                      <div className="sub-classify-item-mode2"
                                        onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                        data-level="2" data-category-id={ subItem.category_id }
                                        data-compindex={this.props.index} style={{lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height'],flex:`0 0 calc(${ 100/data.customFeature.level2ClassifyColumn + '% - .30rem'})`,textDecoration:data.classifyStyle['text-decoration']}}>{ subItem.name }</div>
                                    )
                                }
                              </React.Fragment>
                            ))
                          }
                      </div>
                      )
                    }
                  </React.Fragment>
                ))
              }
            </ScrollView>
        </div>
          <ScrollView className={`vessel-area scroll-ele ${ data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode: ''}`}
            data-compindex={this.props.index}
            scroll-y={true}
            lower-threshold="100"
            data-curpage={data.curpage}
            bindscrolltolower={this.pageScrollFunc}
            style={{opacity:data.vesselStyle['opacity'],marginTop:data.vesselStyle['margin-top'],height:data.customFeature.height}} >
            <div className="js-list-container" data-list-index="0" style={{minHeight:data.is_more==1?'':'auto'}}>
              {
                data.list_data && data.list_data.map((item, index) => (
                  <div key={index} className={`list-vessel clearfix ${data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : ''} background-ele`}
                    style={{backgroundColor:data.vesselStyle['lineBackgroundColor'],backgroundImage:data.vesselStyle['lineBackgroundImage'],marginBottom:data.vesselStyle['margin']+'px'}}
                    data-dataid={data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : (item.id || item.form_data.id)}
                    data-router={data.customFeature.link}
                    data-compindex={this.props.index}
                    data-index={index}
                    data-isseckill={(item.form_data.is_seckill && item.form_data.is_seckill) || ''}
                    onClick={(e) => {this.listVesselTurnToPage(e);e.stopPropagation()}}>
                    {content.map((componentData, componentIndex) => 
                      <CustomComponent key={componentIndex} index={componentIndex} data={componentData} dynamicData={item['form_data']}/>
                    )}
                    </div>
                ))
              }
            </div>
            {/* 加载状态/点击按钮 */}
            <Others></Others>
            {
              !!data.classifyAreaLevel2Show && (
                <div className='dynamic-classify-cover' onClick={this.hideCover} data-compindex={this.props.index}>
                  <div className='dynamic-classify-cover'></div>
                </div>
              )
            }
          </ScrollView>
          <div className={data.customFeature.topHover ? 'bottomHover' : ''} style={{height:'.02rem'}}></div>
        </div>
      )
    }
    // 二级竖版
    const $level2VerticalNopic = () => {
      return (
        <div 
          className="element dynamic-classify type-level2-vertical-nopic"
          style={{...styleObj,height: data.customFeature.autoHeight == 1 ? `calc(100vh -  ${isTabBarPage ? '48px': '0'} + ${data.topNavBarHeight || 0}px)` : '' }}
          // bindanimationend="animationEnd"
          data-compindex={this.props.index}>
            {
              !data.customFeature.level2ClassifyStyle ?
                (
                  <React.Fragment>
                    <ScrollView className={`classify-area mode-${ data.classifyStyle.mode }`} scroll-y={true}
                      style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),marginTop:data.classifyStyle['margin-top'],backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],textDecoration:data.classifyStyle['text-decoration'],color:data.classifyStyle['color']}}>
                      {
                        data.classifyData && data.classifyData.map((item, index) => (
                          <React.Fragment key={index}>
                            {
                              item.category_id == '' ?
                                (
                                  <React.Fragment>
                                    {
                                      item.category_id == data.currentCategory[0] ?
                                        (
                                          <div className="dynamic-classify-item selected"
                                            style={{backgroundColor:data.classifyStyle.selectedBackgroundColor,color:data.classifyStyle.selectedColor,height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2" data-category-id={ item.category_id }
                                            data-compindex={this.props.index}>
                                            <span style={{textDecoration:data.classifyStyle['text-decoration']}}>全部</span>
                                            <i className="leftline" style={{borderColor:data.classifyStyle.selectedColor}}></i>
                                          </div>
                                        )
                                        :
                                        (
                                          <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                            style={{height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            data-level="2" data-category-id={ item.category_id } data-compindex={this.props.index}>
                                            <span style={{textDecoration:data.classifyStyle['text-decoration']}}>全部</span>
                                          </div>
                                        )
                                    }
                                  </React.Fragment>
                                )
                                :
                                (
                                  <React.Fragment>
                                    {
                                      item.category_id == data.currentCategory[0] ?
                                        (
                                          <div className="dynamic-classify-item selected"
                                            style={{backgroundColor:data.classifyStyle.selectedBackgroundColor,color:data.classifyStyle.selectedColor,height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="1" data-category-id={ item.category_id }
                                            data-compindex={this.props.index} data-has-subclass={item.subclass && item.subclass.length} data-subclass-id={item.subclass && item.subclass.length?item.subclass[0]['category_id']:''}>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                            <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                            <i className="leftline" style={{borderColor:data.classifyStyle.selectedColor}}></i>
                                          </div>
                                        )
                                        :
                                        (
                                          <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                            style={{height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            data-level="1" data-category-id={ item.category_id } data-compindex={this.props.index}
                                            data-has-subclass={item.subclass && item.subclass.length} data-subclass-id={item.subclass && item.subclass.length?item.subclass[0]['category_id']:''}>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                            <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                          </div>
                                        )
                                    }
                                  </React.Fragment>
                                )
                            }
                          </React.Fragment>
                        ))
                      }
                    </ScrollView>
                    <ScrollView className="sub-classify-area" hidden={ !data.classifyAreaLevel2Show }
                      onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-hide-subclass="1" data-compindex={this.props.index}
                      style={{left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),width:`calc(100% - ${DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])})`,}}
                      scroll-y={true}>
                      {
                        data.classifyData && data.classifyData.map((item, index) => (
                          <React.Fragment key={index}>
                            {
                              item.category_id == data.currentCategory[0] && (
                                <div className="sub-classify-item-list"
                                  style={{fontSize:data.customFeature['secFontSize'],fontWeight:data.customFeature['secFontWeight'],fontWeight:data.customFeature['secFontStyle'],color:data.customFeature['secColor']}}>
                                  {
                                    item.subclass && item.subclass.map((subItem, subIndex) => (
                                      <React.Fragment>
                                        {
                                          subItem.category_id == data.currentCategory[1] ?
                                            (
                                              <div className="sub-classify-item selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                style={{backgroundColor:data.classifyStyle['selectedBackgroundColor'],color:data.classifyStyle['sec-select-font-color'],lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height']}}>{ subItem.name }</div>
                                            )
                                            :
                                            (
                                              <div className="sub-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                style={{backgroundColor:data.classifyStyle['sec-background-color'],color:data.classifyStyle['sec-font-color'],lineHeight:data.classifyStyle['line-height'],height:data.classifyStyle['height']}}>{ subItem.name }</div>
                                            )
                                        }
                                      </React.Fragment>
                                    ))
                                  }
                                </div>
                              )
                            }
                          </React.Fragment>
                        ))
                      }
                    </ScrollView>
                    <ScrollView className={`vessel-area scroll-ele ${ data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode: ''}`}
                      data-compindex={this.props.index} scroll-y={true} lower-threshold="100" data-curpage={data.curpage}
                      bindscrolltolower={this.pageScrollFunc}
                      style={{left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),width:`calc(100% - ${ DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) })`,opacity:data.vesselStyle['opacity'],marginTop:data.vesselStyle['margin-top']}}>
                      {
                        !!+(data.customFeature.showActiveImage && data.currentCategory && data.currentCategory[0] == data.classifyData[0].category_id) && (
                          <div className="active-image">
                            <img src={data.customFeature.activeImage} onClick={this.bindEventTapHandler}
                              data-eventparams={JSON.stringify(data.customFeature)}
                              style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth),height:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight),borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius'])}}/>
                          </div>
                        )
                      }
                      <div className="js-list-container" data-list-index="0"
                        style={{backgroundColor:data.vesselStyle['background-color'],backgroundImage:data.vesselStyle['background-image'],minHeight:data.is_more==1?'':'auto'}}>
                        {
                          data.list_data && data.list_data.map((item, index) => (
                            <div
                              key={index}
                              className={`list-vessel clearfix ${data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : ''} background-ele`}
                              style={{backgroundColor:data.vesselStyle['lineBackgroundColor'],backgroundImage:data.vesselStyle['lineBackgroundImage'],marginBottom:data.vesselStyle['margin']+'px'}}
                              data-dataid={data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : (item.id || item.form_data.id)}
                              data-router={data.customFeature.link} data-compindex={this.props.index} data-index={index}
                              data-isseckill={(item.form_data.is_seckill && item.form_data.is_seckill) || ''} 
                              onClick={(e) => {this.listVesselTurnToPage(e);e.stopPropagation()}}>
                              {content.map((componentData, componentIndex) => 
                                <CustomComponent key={componentIndex} index={componentIndex} data={componentData} dynamicData={item['form_data']}/>
                              )}
                            </div>
                          )) 
                        }
                      </div>
                      {/* 加载状态/点击按钮 */}
                      <Others></Others>
                    </ScrollView>   
                  </React.Fragment>
                )
                :
                (
                  <React.Fragment>
                    <ScrollView className={`classify-area mode-${ data.classifyStyle.mode }`} scroll-y={true}
                      style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),marginTop:data.classifyStyle['margin-top'],backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],textDecoration:data.classifyStyle['text-decoration'],color:data.classifyStyle['color']}}>
                      {
                        data.classifyData && data.classifyData.map((item, index) => (
                          <React.Fragment key={index}>
                            {
                              item.category_id == '' ?
                                (
                                  <React.Fragment>
                                    {
                                      item.category_id == data.currentCategory[0] ? 
                                        (
                                          <div className="dynamic-classify-item selected"
                                            style={{backgroundColor:data.classifyStyle.selectedBackgroundColor,color:data.classifyStyle.selectedColor,height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2" data-category-id={ item.category_id }
                                            data-compindex={this.props.index}>
                                            <span>全部</span>
                                            <i className="leftline" style={{borderColor:data.classifyStyle.selectedColor}}></i>
                                          </div>
                                        )
                                        :
                                        (
                                          <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                            style={{height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            data-level="2" data-category-id={ item.category_id } data-compindex={this.props.index}>
                                            <span>全部</span>
                                          </div>
                                        )
                                    }
                                  </React.Fragment>
                                )
                                :
                                (
                                  <React.Fragment>
                                    {
                                      item.category_id == data.currentCategory[0] ?
                                        (
                                          <div className="dynamic-classify-item selected"
                                            style={{backgroundColor:data.classifyStyle.selectedBackgroundColor,color:data.classifyStyle.selectedColor,height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="1" data-category-id={ item.category_id }
                                            data-compindex={this.props.index} data-has-subclass={item.subclass && item.subclass.length} data-subclass-id={item.subclass && item.subclass.length?item.subclass[0]['category_id']:''}>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                            <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                            <i className="leftline" style={{borderColor:data.classifyStyle.selectedColor}}></i>
                                          </div>
                                        )
                                        :
                                        (
                                          <div className="dynamic-classify-item" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}}
                                            style={{height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height']}}
                                            data-level="1" data-category-id={ item.category_id } data-compindex={this.props.index}
                                            data-has-subclass={item.subclass && item.subclass.length} data-subclass-id={item.subclass && item.subclass.length?item.subclass[0]['category_id']:''}>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                            <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                                            {
                                              !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                                                <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                                              )
                                            }
                                          </div>
                                        )
                                    }
                                  </React.Fragment>
                                )
                            }
                          </React.Fragment>
                        ))
                      }
                    </ScrollView>
                    <div>
                      {
                        !data.customFeature.isShowSecondIcon ?
                          // 子分类不带图标
                          (
                            <React.Fragment>
                              {
                                data.currentCategory && data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) && (
                                  <div className="sub-classify-style2-box" style={{position:'relative',width:`calc(100% - ${DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])})`}}>
                                    {
                                      data.currentCategory && (
                                        <ScrollView className="" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-hide-subclass="1" data-compindex={this.props.index} className="sub-classify-style2" style={{height: '.74rem',left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])}} scroll-x={true}>
                                          {
                                            data.classifyData && data.classifyData.map((item, index) => (
                                              <React.Fragment key={index}>
                                                {
                                                  item.category_id == data.currentCategory[0] && (
                                                    <div
                                                      key={index}
                                                      className="sub-classify-item-list style2"
                                                      style={{fontSize:data.customFeature['secFontSize'],fontWeight:data.customFeature['secFontWeight'],fontWeight:data.customFeature['secFontStyle'],color:data.customFeature['secColor'],marginRight: DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) <= 6 ? '0' : '.74rem' }}>
                                                      {
                                                        item.subclass && item.subclass.map((subItem, subIndex) => (
                                                          <React.Fragment key={subIndex}>
                                                            {
                                                              subItem.category_id == data.currentCategory[1] ?
                                                                (
                                                                  <div className="sub-classify-item style2 selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                                    data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                                    style={{textDecoration:data.customFeature['secTextDecoration'],backgroundColor:DynamicClassifyModule.RGB2RGBA(data.classifyStyle['sec-select-font-color'],0.2),...data.textStyle,color:data.classifyStyle['sec-select-font-color'],marginRight:DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right'])}}>
                                                                    { subItem.name }</div>
                                                                )
                                                                :
                                                                (
                                                                  <div className="sub-classify-item style2" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                                    data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                                    style={{textDecoration:data.customFeature['secTextDecoration'],...data.textStyle,color:data.classifyStyle['sec-font-color'],marginRight:DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right'])}}>
                                                                    { subItem.name }</div>
                                                                )
                                                            }
                                                          </React.Fragment>
                                                        ))
                                                      }
                                                    </div>
                                                  )
                                                }
                                              </React.Fragment>
                                            ))
                                          }
                                        </ScrollView>
                                      )
                                    }
                                    {
                                      data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0])>6 && (
                                        <div className={`show-all-classify ${data.showAllSubclassifySelect?'active':''}`} data-compindex={this.props.index} onClick={(e) => {this.showAllSubclassify(e);e.stopPropagation()}} style={{right:'-'+DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) }}>
                                          <span className="icon-downarrow ico-moon"></span>
                                        </div>
                                      )
                                    }
                                  </div>
                                )
                              }
                            </React.Fragment>
                          )
                          :
                          // 子分类带图标
                          (
                            <React.Fragment>
                              {
                                data.currentCategory && data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) && (
                                  <div className="sub-classify-style2-box" style={{position:'relative',width:`calc(100% - ${DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])})`}}>
                                    {
                                      data.currentCategory && (
                                        <ScrollView className="" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-hide-subclass="1" data-compindex={this.props.index} className="sub-classify-style2" style={{backgroundColor:data.classifyStyle['sec-background-color'],height:`calc(${DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size'])} + ${DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size'])} + .60rem)`,left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])}} scroll-x={true}>
                                          {
                                            data.classifyData && data.classifyData.map((item, index) => (
                                              <React.Fragment key={index}>
                                                {
                                                  item.category_id == data.currentCategory[0] && (
                                                    <div
                                                      key={index}
                                                      className="sub-classify-item-list style2"
                                                      style={{fontSize:data.customFeature['secFontSize'],fontWeight:data.customFeature['secFontWeight'],fontWeight:data.customFeature['secFontStyle'],color:data.customFeature['secColor'],marginRight:DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) <= 6 ? '0' : '.74rem' }}>
                                                      {
                                                        item.subclass && item.subclass.map((subItem, subIndex) => (
                                                          <React.Fragment key={subIndex}>
                                                            {
                                                              subItem.category_id == data.currentCategory[1] ?
                                                                (
                                                                  <div className="sub-classify-item style2-hasicon selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                                    data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                                    style={{color:data.classifyStyle['sec-select-font-color'],height: `calc(${DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size'])} + ${DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size'])} + .60rem)`,maxWidth: `calc(${DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size'])} + .40rem)`,marginRight:DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right'])}}>
                                                                    <img className="classify-iamge" src={ item.category_id == subItem.category_id ? item.cover : subItem.cover } style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']),height:DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']),borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius'])}}/>
                                                                    <span className="text" style={{textDecoration:data.customFeature['secTextDecoration'],...data.textStyle,color:data.classifyStyle['sec-select-font-color']}}>{ subItem.name }</span>
                                                                  </div>
                                                                )
                                                                :
                                                                (
                                                                  <div className="sub-classify-item style2-hasicon" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                                    data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                                    style={{color:data.classifyStyle['sec-font-color'],height: `calc(${DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size'])} + ${DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size'])} + .60rem)`,maxWidth: `calc(${DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size'])} + .40rem)`,marginRight:DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right'])}}>
                                                                    <img className="classify-iamge" src={ item.category_id == subItem.category_id ? item.cover : subItem.cover } style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']),height:DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']),borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius'])}}/>
                                                                    <span className="text" style={{textDecoration:data.customFeature['secTextDecoration'],...data.textStyle}}>{ subItem.name }</span>
                                                                  </div>
                                                                )
                                                            }
                                                          </React.Fragment>
                                                        ))
                                                      }
                                                    </div>
                                                  )
                                                }
                                              </React.Fragment>
                                            ))
                                          }
                                        </ScrollView>

                                      )
                                    }
                                    {
                                      data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0])>6 && (
                                        <div className="show-all-classify-hasicon" data-compindex={this.props.index} onClick={(e) => {this.showAllSubclassify(e);e.stopPropagation()}} style={{height: `calc(${DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size'])} + ${DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size'])} + .60rem)`,right:'-'+ DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) }}>
                                          {
                                            !data.showAllSubclassifySelect ?
                                              (
                                                <div className="hasicon-inner">
                                                  <span>查看全部</span>
                                                  <span className="icon-downarrow ico-moon"></span>
                                                </div>
                                              )
                                              :
                                              (
                                                <div className="hasicon-inner">
                                                  <span>收起</span>
                                                  <span className="icon-downarrow ico-moon" style={{transform: 'rotate(180deg)'}}></span>
                                                </div>
                                              )
                                          }
                                        </div>
                                      )
                                    }
                                  </div>
                                )
                              }
                            </React.Fragment>
                          )
                      }         
                      {/* 展开子分类 */}
                      {
                        !!+data.showAllSubclassifySelect && (
                          <React.Fragment>
                            {
                              data.classifyData && data.classifyData.map((item, index) => (
                                <React.Fragment key={index}>
                                  {
                                    item.category_id == data.currentCategory[0] && (
                                      <div className="all-sub-clssify-box style2" style={{width:`calc(100% - ${DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])})`, top:data.customFeature.isShowSecondIcon? `calc(${DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size'])} + ${DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size'])} + .60rem)` :'.76rem',right:'0'}}>
                                        {
                                          item.subclass && item.subclass.map((subItem, subIndex) => (
                                            <React.Fragment key={subIndex}>
                                              {
                                                subItem.category_id == data.currentCategory[1] ?
                                                  (
                                                    <div className="sub-classify-box-item style2 selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                      data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                      style={{...data.textStyle,backgroundColor:DynamicClassifyModule.RGB2RGBA(data.classifyStyle['sec-select-font-color'],0.2),color:data.classifyStyle['sec-select-font-color']}}>
                                                      { subItem.name }</div>
                                                  )
                                                  :
                                                  (
                                                    <div className="sub-classify-box-item style2" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                                      data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                                      style={{...data.textStyle,backgroundColor:'#f0f0f0',color:data.classifyStyle['sec-font-color']}}>
                                                      { subItem.name }</div>
                                                  )
                                              }
                                            </React.Fragment>
                                          ))
                                        }
                                      </div>
                                    )
                                  }
                                </React.Fragment>

                              ))
                            }
                          </React.Fragment>
                        )
                      }
                    </div>
                    <ScrollView className={`vessel-area scroll-ele ${ data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode: ''}`}
                      data-compindex={this.props.index} scroll-y={true} lower-threshold="100" data-curpage={data.curpage}
                      bindscrolltolower={this.pageScrollFunc}
                      style={{left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),width:`calc(100% - ${ DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) })`,opacity:data.vesselStyle['opacity'],marginTop:data.vesselStyle['margin-top']}}>
                      <div className="js-list-container" data-list-index="0" style={{minHeight:data.is_more==1?'':'auto'}}>
                        <div className="classify-style2-item" style={{backgroundColor:data.vesselStyle['background-color'],paddingTop: data.currentCategory && (!data.currentCategory[0] ? '' : (data.customFeature.isShowSecondIcon ? '1.6rem':'.74rem'))}}>
                          {
                            !!+data.showAllSubclassifySelect && (
                              <div className="show-all-subclassify-laybox" data-compindex={this.props.index} bindtap="showAllSubclassify" style={{left:'0',width:'100%',opacity:data.vesselStyle['opacity'],marginTop:data.vesselStyle['margin-top']}}></div>
                            )
                          }
                          {
                            !!+(data.customFeature.showActiveImage && data.currentCategory && data.currentCategory[0] == data.classifyData[0].category_id) && (
                              <div className="active-image">
                                <img src={data.customFeature.activeImage} onClick={this.bindEventTapHandler}
                                  data-eventparams={JSON.stringify(data.customFeature)}
                                  style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth),height:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight),borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius'])}}/>
                              </div>
                            )
                          }
                          {
                            data.list_data && data.list_data.map((item, index) => (
                              <div
                                key={index}
                                className={`list-vessel clearfix ${data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : ''} background-ele`}
                                style={{backgroundColor:data.vesselStyle['lineBackgroundColor'],backgroundImage:data.vesselStyle['lineBackgroundImage'],marginBottom:data.vesselStyle['margin']+'px'}}
                                data-dataid={data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : (item.id || item.form_data.id)}
                                data-router={data.customFeature.link} data-compindex={this.props.index} data-index={index}
                                data-isseckill={(item.form_data.is_seckill && item.form_data.is_seckill) || ''} onClick={(e) => {this.listVesselTurnToPage(e);e.stopPropagation()}}>
                                {content.map((componentData, componentIndex) => 
                                  <CustomComponent key={componentIndex} index={componentIndex} data={componentData} dynamicData={item['form_data']}/>
                                )}
                              </div>
                            ))
                          }
                        </div>
                      </div>
                      {/* 加载状态/点击按钮 */}
                      <Others></Others>
                    </ScrollView>
                  </React.Fragment>
                )
            }
        </div>
      )
    }
    // 二级大图
    const $level2VerticalWithpic = () => {
      return (
        <div className="element dynamic-classify type-level2-vertical-withpic" style={{...styleObj,height: `calc(100vh - ${isTabBarPage ? '48px': '0'} - ${data.searchHeight || 0}px)`}}
          // bindanimationend="animationEnd"
          data-compindex={this.props.index}>
          <ScrollView className={`classify-area mode-${ data.classifyStyle.mode }`} scroll-y={true} style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),marginTop:data.classifyStyle['margin-top'],backgroundImage:data.classifyStyle['background-image'],backgroundColor:data.classifyStyle['background-color'],opacity:data.classifyStyle['opacity'],fontSize:data.classifyStyle['font-size'],fontWeight:data.classifyStyle['font-weight'],fontStyle:data.classifyStyle['font-style'],textDecoration:data.classifyStyle['text-decoration'],color:data.classifyStyle['color']}}>
            {
              data.classifyData && data.classifyData.map((item, index) => (
                <React.Fragment key={index}>
                  {
                    item.category_id == data.currentCategory[0] ?
                      (
                        <div className="dynamic-classify-item selected" style={{backgroundColor:data.classifyStyle.selectedBackgroundColor,color:data.classifyStyle.selectedColor,height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height'],textDecoration:data.classifyStyle['text-decoration']}}
                          onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="1" data-category-id={ item.category_id } data-compindex={this.props.index} data-index={index}>
                          {
                            !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                          <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                          {
                            !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                          <i className="leftline" style={{borderColor:data.classifyStyle.selectedColor}}></i>
                        </div>
                      )
                      :
                      (
                        <div className="dynamic-classify-item" style={{height:data.classifyStyle.height,lineHeight:data.classifyStyle['line-height'],textDecoration:data.classifyStyle['text-decoration']}} onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="1" data-category-id={ item.category_id } data-compindex={this.props.index} data-index={index}>
                          {
                            !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginRight:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                          <span style={{textDecoration: data.classifyStyle['text-decoration'] }}>{item.name}</span>
                          {
                            !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && (
                              <img src={item.cover} style={{verticalAlign:'middle',display:'inline-block',marginLeft:'.10rem',width:'.30rem',height:'.30rem',borderRadius:data.classifyStyle['first-border-radius'], ...data.listIconStyle}}/>
                            )
                          }
                        </div>
                      )
                  }
                </React.Fragment>
              ))
            }
          </ScrollView>
          {/* 点击切换 */}
          {
            !data.customFeature.scrollChangeClassify && (
              <div>
                {
                  data.classifyData && data.classifyData.map((item, index) => (
                    <ScrollView key={index} className="sub-classify-area" hidden={index != data.customFeature.selected }
                      style={{left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),width:`calc(100% - ${DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])})`,backgroundColor:data.classifyStyle['sec-background-color'] || ''}}
                      scroll-y={true} bindscroll="" data-compindex={this.props.index} scroll-top="">
                      {
                        data.customFeature.showActiveImage && index === 0 && (
                          <div className="active-image">
                            <img src={data.customFeature.activeImage} onClick={this.bindEventTapHandler} data-eventparams={JSON.stringify(data.customFeature)}
                              style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth),height:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight),borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius'])}}/>
                          </div>
                        )
                      }
                      <div style={{minHeight: data.SCAMinHeight}}>
                        <div className="sub-classify-item-list"
                          style={{fontSize:data.customFeature['secFontSize'],fontWeight:data.customFeature['secFontWeight'],fontWeight:data.customFeature['secFontStyle'],color:data.customFeature['secColor']}}>
                          <div className="first-classify-name"><span style={{textDecoration:data.classifyStyle['text-decoration']}}>{item.name}</span></div>
                          <div className={`sub-classify-main ${data.customFeature.structure == 2 ? 'horizontal-style' : ''}`}>
                            {
                              item.subclass && item.subclass.map((subItem, subIndex) => (
                                <React.Fragment key={subIndex}>
                                  {
                                    subItem.category_id == data.currentCategory[1] ?
                                      (
                                        <div className="sub-classify-item selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                          data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                          style={{...data.classifyItemStyle}}>
                                          {
                                            !data.customFeature.showClassifyIcon && (
                                              <img style={{borderRadius:DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius),...data.imgStyle}} mode="scaleToFill" src={subItem.cover}/>
                                            )
                                          }
                                          <div className="name" style={{...data.textStyle}}><span style={{...data.textStyle}}>{ subItem.name }</span></div>
                                        </div>
                                      )
                                      :
                                      (
                                        <div className="sub-classify-item selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2"
                                          data-category-id={ subItem.category_id } data-compindex={this.props.index}
                                          style={{...data.classifyItemStyle}}>
                                          {
                                            !data.customFeature.showClassifyIcon && (
                                              <img style={{borderRadius:DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius),...data.imgStyle}} mode="scaleToFill" src={subItem.cover}/>
                                            )
                                          }
                                          <div className="name" style={{...data.textStyle}}><span style={{...data.textStyle}}>{ subItem.name }</span></div>
                                        </div>
                                      )
                                  }
                                </React.Fragment>
                              )) 
                            }
                          </div>
                        </div>
                      </div>
                    </ScrollView>
                  ))
                }
              </div>

            )
          }
          {/* 滚动切换 */}
          {
            !!data.customFeature.scrollChangeClassify && (
              <ScrollView className="sub-classify-area" style={{left:DynamicClassifyModule.pxToRpx(data.classifyStyle['width']),width:`calc(100% - ${DynamicClassifyModule.pxToRpx(data.classifyStyle['width'])})`,backgroundColor:data.classifyStyle['sec-background-color'] || ''}} scroll-y={true} bindscroll={this.dynamicSubClassifyAreaScrollEvent} data-compindex={this.props.index} data-offset-height={JSON.stringify(data.SCAOffHeight)} data-offset-top-arr={JSON.stringify(data.SCILOffsetTopArr)} scroll-top={data.SCAScrollTop}>
                {
                  data.customFeature.showActiveImage && (
                    <div className="active-image">
                      <img src={data.customFeature.activeImage} onClick={this.bindEventTapHandler} data-eventparams={JSON.stringify(data.customFeature)} style={{width:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth),height:DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight),borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius'])}}/>
                    </div>
                  )
                }
                <div style={{minHeight: data.SCAMinHeight}}>
                  {
                    data.classifyData && data.classifyData.map((item, index) => (
                      <div key={index} className="sub-classify-item-list" style={{fontSize:data.customFeature['secFontSize'],fontWeight:data.customFeature['secFontWeight'],fontWeight:data.customFeature['secFontStyle'],color:data.customFeature['secColor']}}>
                        <div className="first-classify-name"><span style={{textDecoration:data.classifyStyle['text-decoration']}}>{item.name}</span></div>
                        <div className={`sub-classify-main ${data.customFeature.structure == 2 ? 'horizontal-style' : ''}`}>
                          {
                            item.subclass && item.subclass.map((subItem, subIndex) => (
                              <React.Fragment key={subIndex}>
                                {
                                  subItem.category_id == data.currentCategory[1] ?
                                    (
                                      <div className="sub-classify-item selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2" data-category-id={ subItem.category_id } data-compindex={this.props.index} style={{...data.classifyItemStyle}}>
                                        {
                                          !data.customFeature.showClassifyIcon && (
                                            <img mode="scaleToFill" style={{borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius']),...data.imgStyle}} src={ subItem.cover }/>
                                          )
                                        }
                                        <div className="name" style={{...data.textStyle}}><span style={{...data.textStyle}}>{ subItem.name }</span></div>
                                      </div>
                                    )
                                    :
                                    (
                                      <div className="sub-classify-item selected" onClick={(e) => {this.tapDynamicClassifyFunc(e);e.stopPropagation()}} data-level="2" data-category-id={ subItem.category_id } data-compindex={this.props.index} style={{...data.classifyItemStyle}}>
                                        {
                                          !data.customFeature.showClassifyIcon && (
                                            <img mode="scaleToFill" style={{borderRadius:DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius']), ...data.imgStyle}} src={ subItem.cover }/>
                                          )
                                        }
                                        <div className="name" style={{...data.textStyle}}><span style={{...data.textStyle}}>{ subItem.name }</span></div>
                                      </div>
                                    )
                                }
                              </React.Fragment>
                            ))
                          }
                        </div>
                      </div>
                    ))
                  }
                </div>
              </ScrollView>

            )
          }
        </div>
      )
    }
    return (
      <div className="custom-component dynamic-classify">
        {
          classifyType === 'level1-horizontal' && $level1Horizontal()
        }
        {
          classifyType === 'level1-vertical' && $level1Vertical()
        }
        {
          classifyType === 'level1-vertical-withpic' && $level1VerticalWithpic()
        }
        {
          classifyType === 'level2-horizontal' && $level2Horizontal()
        }
        {
          classifyType === 'level2-vertical-nopic' && $level2VerticalNopic()
        }
        {
          classifyType === 'level2-vertical-withpic' && $level2VerticalWithpic()
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/dynamic-classify-custom-component/DynamicClassifyCustomComponent.jsx